/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Stack, Box } from 'sarsaparilla';
import cx from 'classnames';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout';
import DetailedAvailabilityInformationRequired from './DetailedAvailabilityInformationRequired';

function DetailedAvailabilityFilter({ children, isCheckAvailabilityDisabled }) {
    const {
        isInformationRequired,
        isMobileApp,
        isShowAvailabilityFilters,
        setIsShowAvailabilityFilters,
    } = useContext(LayoutControlContext);

    const childrenArray = React.Children.toArray(children);

    const otherChildren = childrenArray.filter(
        ({ type }) => type !== DetailedAvailabilityInformationRequired
    );
    // const detailedAvailabilityInformationRequired = childrenArray.find(({ type }) => type === DetailedAvailabilityInformationRequired)

    return (
        (isShowAvailabilityFilters || !isMobileApp) && (
            <Stack
                role="group"
                aria-label="Grid options"
                // TODO 100vh - Size of Check Availability Button when isMobileApp
                className={cx('per-availability-filters mt-0', {
                    'mobile-app': isMobileApp,
                })}
            >
                {/* TODO refactor InformationRequired component to have responsive design
                {(isInformationRequired && isMobileApp) && detailedAvailabilityInformationRequired} */}

                {otherChildren}

                {isMobileApp && (
                    <Box
                        className={cx('check-availability', {
                            'mobile-app': isMobileApp,
                        })}
                    >
                        <Button
                            appearance="primary"
                            shouldFitContainer
                            onClick={() => setIsShowAvailabilityFilters(false)}
                            isDisabled={
                                isInformationRequired || isCheckAvailabilityDisabled
                            }
                            screenReaderTextBefore="Hide filter options and show availabilities"
                        >
                            Check Availability
                        </Button>
                    </Box>
                )}
            </Stack>
        )
    );
}

DetailedAvailabilityFilter.propTypes = {
    children: PropTypes.node,
    isCheckAvailabilityDisabled: PropTypes.bool,
};

export default DetailedAvailabilityFilter;
